module.exports = __webpack_public_path__ + "img/way_image_03.e7caf84.svg";